var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreateSeq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.92864 4.80348C4.28637 4.49383 4.77669 4.41465 5.21357 4.59595L19.7364 10.6221C20.2109 10.8189 20.5 11.2519 20.5 11.7656C20.5 12.2794 20.2109 12.7123 19.7364 12.9092L5.21357 18.9353C4.77731 19.1163 4.28691 19.038 3.92861 18.7278C3.57091 18.4181 3.42235 17.9442 3.53925 17.4858L4.96638 11.8892L4.99789 11.7656L4.96638 11.6421L3.53925 6.04549C3.42236 5.58712 3.57094 5.11319 3.92864 4.80348Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateSeq);
export default __webpack_public_path__ + "static/media/createSeq.15bbe0e784a76bd19b2749d0a8eb97d8.svg";
export { ForwardRef as ReactComponent };